<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M13.8026 10.5493L20.8562 2.52637H19.1847L13.0601 9.49255L8.16839 2.52637H2.52637L9.92361 13.0605L2.52637 21.4737H4.19794L10.6657 14.1172L15.8317 21.4737H21.4737L13.8022 10.5493H13.8026ZM11.5132 13.1533L10.7637 12.1043L4.80023 3.75764H7.36766L12.1802 10.4937L12.9297 11.5426L19.1855 20.2985H16.6181L11.5132 13.1537V13.1533Z"
    fill="currentColor"
  />
</svg>
